/**
 * Date Validation Utilities
 * Reusable date validation functions
 */

import { parseFlexibleDateToMMDDYYYY } from './date';

/**
 * Validate that a date string is parseable in any accepted flexible format.
 *
 * Accepted formats: MM-DD-YYYY, MM/DD/YYYY, M-D-YYYY, M/D/YYYY,
 *                   MM-DD-YY, MM/DD/YY, M-D-YY, M/D/YY
 * 2-digit years are expanded to 20YY.
 *
 * @param dateStr - Date string to validate
 * @returns `true` when the string is empty/blank or a valid parseable date; `false` otherwise.
 */
export const isValidDateFormat = (dateStr: string): boolean => {
  if (!dateStr?.trim()) return true; // Empty is considered valid (field not required by this helper)
  return parseFlexibleDateToMMDDYYYY(dateStr) !== null;
};

